import { useState } from "react";
import { useIntl } from "react-intl";
import { Form, Input } from "semantic-ui-react";
import { Config } from "../../../config/api";
import { useDebounce } from "../../../libs/component_utils";
import { useRetargetingSegmentsContext } from "../index/context";

const RetargetingSegmentsFilterControl = () => {
  const intl = useIntl();
  const { updateFilters, state } = useRetargetingSegmentsContext();
  const [titleValue, setTitleValue] = useState(state.filter.title ?? "");

  const updateTitleLocalState = (title) => setTitleValue(title);
  const updateTitleFilter = (title) => updateFilters({ title });
  const updateTitleFilterDebounced = useDebounce(Config.search_debounce_delay, (title) => {
    if (title.length === 0 || title.length >= 3) {
      updateTitleFilter(title);
    }
  });

  const handleTitleChange = (_, { value }) => {
    updateTitleLocalState(value);
    updateTitleFilterDebounced(value);
  };

  const handleTitleKeyPress = (e) => {
    if (e.charCode === 13) {
      // no need to debounce on enter
      updateTitleFilter(e.target.value);
      updateTitleLocalState(e.target.value);
    }
  };

  return (
    <Form
      autoComplete="off"
      noValidate
      size="tiny"
      style={{ marginTop: "15px", flex: 1 }}
    >
      <Form.Group widths={1}>
        <Form.Field>
          <label>
            {intl.formatMessage({
              id: "LABEL_BRAND_SKU_SEGMENT",
              defaultMessage: "Brand and SKU Segment",
            })}
          </label>
          <Input
            icon={
              titleValue !== ""
                ? {
                    name: "x",
                    className: "input-clear-icon",
                    link: true,
                    onClick: () => {
                      setTitleValue("");
                      updateFilters({ title: "" });
                    },
                  }
                : "search"
            }
            iconPosition={titleValue !== "" ? null : "left"}
            placeholder={intl.formatMessage({
              id: "HINT_SEARCH_SEGMENT_NAME",
              defaultMessage: "Search segments by name",
            })}
            value={titleValue}
            onChange={handleTitleChange}
            onKeyPress={handleTitleKeyPress}
            name="title"
          />
        </Form.Field>
      </Form.Group>
    </Form>
  );
};

export default RetargetingSegmentsFilterControl;
